import React, { useState } from 'react';

import { ContactsParagraph, StyledIntroduction } from './Contacts.styled';
import ContactModal from 'components/Footer/ContactModal';
import { useContactInfo } from 'hooks/useContactInfo';
import theme from 'kb-shared/theme';

import { INTRODUCTION, QUESTIONS_CONTACT_MESSAGE } from '../../InterstitialModal.constants';

export const Contacts = () => {
  const [visible, setVisible] = useState(false);
  const { numberLabel, number } = useContactInfo();

  return (
    <>
      <ContactsParagraph>
        <StyledIntroduction>{INTRODUCTION}</StyledIntroduction>
        <strong>
          {QUESTIONS_CONTACT_MESSAGE}{' '}
          <a href={`tel:${number}`} style={{ color: `${theme.colors.semantic.darkBlue}` }}>
            {numberLabel}.{' '}
          </a>
        </strong>
      </ContactsParagraph>
      <ContactModal visible={visible} onDismiss={() => setVisible(false)} />
    </>
  );
};

export default Contacts;
